import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function EmotionSection() {
  const benefits = [{
    title: 'Hydration that actually lasts.',
    desc: 'Deep cellular hydration that holds, not surface moisture.'
  }, {
    title: 'The glass skin effect.',
    desc: 'Luminous, even, impossibly smooth.'
  }, {
    title: 'Skin that feeds itself.',
    desc: 'Peptides and vitamins delivered where serums can never reach.'
  }];
  return <section className="py-20 md:py-32 bg-cream" data-id="element-97">
      <div className="container mx-auto px-4 md:px-6" data-id="element-98">
        <FadeIn data-id="element-99">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-center max-w-3xl mx-auto mb-16 md:mb-24 text-primary" data-id="element-100">
            The dewy, lit-from-within skin you've been chasing.
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 max-w-6xl mx-auto" data-id="element-101">
          {benefits.map((benefit, index) => <FadeIn key={index} delay={index * 200} className={`flex flex-col ${index === 1 ? 'md:mt-12' : ''} ${index === 2 ? 'md:mt-24' : ''}`} data-id="element-102">
              <div className="bg-cream-dark/40 p-8 md:p-10 rounded-2xl h-full border border-divider/50 hover:border-gold/30 transition-colors duration-500" data-id="element-103">
                <div className="text-gold mb-6 text-2xl" data-id="element-104">✦</div>
                <h3 className="text-xl md:text-2xl font-serif font-medium text-primary mb-4" data-id="element-105">
                  {benefit.title}
                </h3>
                <p className="text-foreground/70 leading-relaxed" data-id="element-106">
                  {benefit.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}